export default "/images/gdpr_logo__large.png";